export var RecoType;
(function (RecoType) {
    RecoType[RecoType["UseItWith"] = 1] = "UseItWith";
    RecoType[RecoType["YouMayLove"] = 2] = "YouMayLove";
    RecoType[RecoType["CatLandingFeaturedItems"] = 3] = "CatLandingFeaturedItems";
    RecoType[RecoType["RecommendedRitual"] = 4] = "RecommendedRitual";
    RecoType[RecoType["PairsWith"] = 5] = "PairsWith";
})(RecoType || (RecoType = {}));
var RecommendationProductDto = (function () {
    function RecommendationProductDto(type, displayValue, productId, productLink) {
        this.RecoType = RecommendationProductDto.RecoType;
        this.displayValue = "";
        this.productId = "";
        this.productLink = "";
        this.type = type;
        this.displayValue = displayValue;
        this.productId = productId;
        this.productLink = productLink;
    }
    RecommendationProductDto.RecoType = RecoType;
    return RecommendationProductDto;
}());
export { RecommendationProductDto };
//# sourceMappingURL=RecommendationProductDto.js.map